import React from 'react';
import { ToastrContext } from '../context/ToastrContext';

export default function useToastr() {
  return React.useContext(ToastrContext);
}
